import React from "react";
import "../../../styles/modal.scss";
import { Subscribe, UnSubscribe, updateList, compare } from "../../../components/utilities";
import ModalSearch from "../../../components/modalSearch";
import ComponentReferences from "../../warehouse/components/componentReferences";
import { Api as Assets } from "../../../services/asset";
import { connect } from "react-redux";

class ComponentClassReferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "__ComponentClassReferences",
      name: "REFERENCE",
      show: false,
      rows: 30,
      data: {
        list: [],
        search: "",
        page: 1,
        rows: 30,
        int: 0,
        end: 0,
        count: 0,
        all: 0,
      },
      select: { _id: "-1", caption: "" },
      change: false,
      update: {}
    };
  }

  eventSetData = (e) => {
    setTimeout(() => {
      this.handleUpdate(e);
    }, 500);
  };

  handleSetData = (e) => {
    this.handleUpdate(e);
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleData = (scroll) => {
    const project_id = this.props.project_id;
    const class_id = this.props.class_id;
    const only = this.props.only;
    const search = this.state.data.search;
    const rows = this.state.rows;
    if (scroll) {
      const page = this.state.data.page + 1;
      Assets.references(project_id, class_id, only, search, page, rows, this.state.data.list).then((result) => {
        const data = result.data;
        this.setState({
          data: data,
        });
      });
    } else {
      Assets.references(project_id, class_id, only, search, 1, rows, [this.state.select]).then((result) => {
        const data = result.data;
        this.setState({
          data: data,
          change: false,
        });
      });
    }
  };

  handleSearch = () => {
    this.handleData(false);
  };

  handleUpdate = (e) => {
    if (compare(this.state.update, e)) {
      const data = updateList(this.state.data, e);
      this.setState({ data: data, change: true, update: e });
    }
  };

  handleCheck = (e) => {
    const _id = this.props.class_id;
    const item = e.item;
    const referece_id = item._id;
    const chk = !item.chk;
    const user_id = this.props.user_id;
    Assets.chkReference(_id, referece_id, chk, user_id).then((result) => {
      if (result.msg === "") {
        let list = this.state.data.list;
        list[e.i].chk = chk;
        this.setState({
          data: {
            ...this.state.data,
            list: list,
          },
        });
      }
    });
  };

  componentDidMount() {
    Subscribe(`${this.state.name}/${this.props.project_id}`, (event) => this.eventSetData(event));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.show) {
      if (prevProps.show !== this.props.show) {
        this.handleData(false);
      }
    }
  }

  componentWillUnmount() {
    UnSubscribe(`${this.state.name}/${this.props.project_id}`, (event) => this.eventSetData(event));
  }

  render() {
    return (
      <React.Fragment>
        <div className="modalList single pt-0 pb-0">
          <div className="modalListFind">
            <ModalSearch
              name="search"
              value={this.state.data.search}
              state={this.props._state}
              onChange={this.handleChange}
              onSearch={this.handleSearch}
            />
          </div>
          <div className="modalListList">
            <ComponentReferences
              id={`${this.state._id}_scroll`}
              height={this.props.height}
              chk={!this.props.only}
              _state={this.props._state}
              list={this.state.data.list}
              select={this.state.select}
              getData={this.handleData}
              onCkeck={this.handleCheck}
              onSetData={this.handleSetData}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    signin: state.sistem.signin,
    project_id: state.sistem.project._id || "-1",
    user_id: state.sistem.profile._id || "-1",
    _view: state.sistem.folder._view || "",
    online: state.sistem.online,
  };
}

export default connect(mapStateToProps)(ComponentClassReferences);
